import { useState } from "react";
import LandSelect from "../../../design/LandSelect";
import Input from "../../../design/Input";
import TableDatalis from "./TableDatalis";
import regx from "../../../../functions/regx";


export default function Visa ({data, setData}) {
    const templateVisa = {land: 'ישראלי', number: '', issue: '', expiry: '', num: 0};
    const head = ["מס'", "לאום", "מס' ויזה", "תאריך הוצאה", "תאריך תפוגה", "", ""];
    const [dataVisa, setDataVisa] = useState(templateVisa);

    function insertVisa () {
        if (regx('passpord', dataVisa.number, false) && regx('date', dataVisa.issue) && regx('date', dataVisa.expiry)) {
            let num;
            if (dataVisa.num === 0) {
                let keys = Object.keys(data.visa);
                num = (keys.length ? Math.max(...keys) : 0) + 1
            } else {
                num = dataVisa.num;
            }
            let visa = {...data.visa, [num]: dataVisa};
            setData({...data, visa: visa});
            setDataVisa(templateVisa);
        }
    }

    return (
        <div>
            <div className="visa">
                <p> לאום </p>
                <LandSelect 
                value={dataVisa.land} 
                onChange={(e) => setDataVisa({...dataVisa, land: e.target.value })} 
                />
                <p>מס' ויזה </p>
                <Input 
                myStyle='input2' 
                value={dataVisa.number} 
                onChange={(e) => setDataVisa({...dataVisa, number: e })} 
                pattern={'passpord'} 
                language={'en'} 
                />
                <p>תאריך הוצאה</p>
                <Input 
                type="date" 
                myStyle='input2' 
                value={dataVisa.issue} 
                onChange={(e) => setDataVisa({...dataVisa, issue: e })} 
                pattern={'date'} 
                />
                <p>תאריך פקיעה</p>
                <Input 
                type="date" 
                myStyle='input2' 
                value={dataVisa.expiry} 
                onChange={(e) => setDataVisa({...dataVisa, expiry: e })} 
                pattern={'date'} 
                /> 
            </div>

            <p className="addPasspord" onClick={() => insertVisa()} > הוסף \ עדכן </p>

            <TableDatalis 
            name={'visa'} 
            head={head} 
            data={data.visa}
            edit={(value) => setDataVisa({...data.visa[value], num: value})}
            myDelete={(value) => {
                let visa = data.visa;
                delete visa[value];
                setData({...data, visa: {...visa}});
            }}
            />
        </div>
    )
}